import React from 'react'
import {
  ListNav,
  List,
  Sidebar
} from './index'
import dummy from '../data'
import { Container, ListFilter } from '../../../components'

const MainContent = () => {
  const [filtered, setFiltered] = React.useState(false)
  const [selected, setSelected] = React.useState('Program')
  const [data, setData] = React.useState(dummy.program)

  React.useEffect(() => {
    if(filtered){
      setData(dummy[selected.toLowerCase()].slice(0, 3))
    }else{
      setData(dummy[selected.toLowerCase()])
    }
  }, [selected, filtered])

  return (
    <Container className="hidden lg:block">
      <div className="flex flex-wrap -mx-4 py-16">
        <aside className="w-3/12 px-4 hidden lg:block">
          <Sidebar setFiltered={setFiltered}/>
        </aside>
        <main className="w-full lg:w-9/12 px-4">
          <ListNav selected={selected} onChange={setSelected}/>
          <ListFilter filtered={filtered} setFiltered={setFiltered}/>
          <List selected={selected} data={data}/>
        </main>
      </div>
    </Container>
  )
}

export { MainContent }